/*
  Adday quick add to the cart drawer, for product card "Add to basket" forms inside an element
  with data-adday-quick-add (sections/featured-products-carousel.liquid, the homepage
  Bestsellers). That section is not a theme section type, so the theme's own QuickAdd never
  attaches and the form used to post to /cart/add and land on the cart page.

  Same steps as the theme's QuickAdd: /cart/add.js with the form (it already carries
  sections=cart-drawer when the cart type is drawer), the 'update:cart:drawer' event re-renders
  the drawer, wetheme.updateCartCount() updates the header bubble, then the drawer opens.
  With no cart drawer, or if the request fails, the form posts as before (cart page).
*/
(() => {
  if (window.AddayQuickAddReady) return;
  window.AddayQuickAddReady = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-adday-quick-add] form.shopify-product-form');
    if (!form || form.dataset.addayNative === 'true') return;
    if (!document.querySelector('cart-drawer') || !window.eventBus) return;
    event.preventDefault();

    const button = form.querySelector('.quick-add-button');
    if (button && button.disabled) return;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
    }

    try {
      const body = new URLSearchParams(new FormData(form));
      if (!body.has('sections')) body.set('sections', 'cart-drawer');
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
      });
      const added = await response.json().catch(() => null);
      if (!response.ok || !added || added.status) throw new Error((added && added.description) || 'Add failed');

      if (added.sections && added.sections['cart-drawer']) {
        window.eventBus.emit('update:cart:drawer', added);
      } else {
        window.eventBus.emit('render:cart:drawer');
      }
      const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);

      const live = form.querySelector('.sr-only[aria-live="polite"]');
      const wrapper = form.closest('[data-product-added]');
      if (live && wrapper) live.textContent = wrapper.getAttribute('data-product-added') || '';

      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
    } catch (error) {
      // Fall back to the normal form post (cart page), so the customer is never stuck.
      form.dataset.addayNative = 'true';
      form.submit();
      return;
    } finally {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      }
    }
  });
})();
